var Account, Icon, m;

m = require('mithril');

Account = require('../../state/Account');

Icon = require('./Icon');

module.exports = {
  controller: function(args) {
    var ctrl, getAccountCode, hashCode, onAccountError, onAccountFound;
    onAccountFound = function(account) {
      ctrl.waiting(false);
      ctrl.statusMessage('Yay, found the account!');
      return account;
    };
    onAccountError = function(error) {
      ctrl.waiting(false);
      ctrl.statusMessage([Icon.warning('LoginPanel__icon'), 'Sorry, those credentials are not valid']);
      return error;
    };
    getAccountCode = function() {
      return Math.abs(hashCode((ctrl.username().toLowerCase().trim()) + ":" + (ctrl.password())));
    };
    hashCode = function(s) {
      return s.split('').reduce((function(a, b) {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a;
      }), 0);
    };
    ctrl = this;
    ctrl.username = m.prop('');
    ctrl.password = m.prop('');
    ctrl.waiting = m.prop(false);
    ctrl.login = function() {
      ctrl.waiting(true);
      ctrl.statusMessage([m('img[src="/imgs/spinner.gif"]'), 'Please wait...']);
      return args.loadAccount(getAccountCode()).then(onAccountFound, onAccountError);
    };
    ctrl.statusMessage = m.prop(null);
    return ctrl;
  },
  view: function(ctrl, args) {
    return m('form.LoginPanel', {
      onsubmit: function(e) {
        e.preventDefault();
        return ctrl.login();
      }
    }, [
      m('h2', 'Change account'), m('label.LoginPanel__field', [
        m('span.LoginPanel__label', 'Username'), m('input.LoginPanel__input[type=text][required=required]', {
          value: ctrl.username(),
          onchange: m.withAttr('value', ctrl.username),
          disabled: ctrl.waiting()
        })
      ]), m('label.LoginPanel__field', [
        m('span.LoginPanel__label', 'Password'), m('input.LoginPanel__input[type=password][required=required]', {
          value: ctrl.password(),
          onchange: m.withAttr('value', ctrl.password),
          disabled: ctrl.waiting()
        })
      ]), ctrl.statusMessage() ? m('.LoginPanel__status', ctrl.statusMessage()) : void 0, m('input.LoginPanel__button[type=submit]', {
        disabled: ctrl.waiting(),
        value: 'Log in'
      })
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,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
